export const RECOMMENDATION_STATUS = {
    STARTED: 0,
    EXTRACTED_TEXT_FROM_RESUME: 1,
    CREATED_QUERY: 2,
    FETCHING_JOBS: 3,
    JOBS_FETCHED: 4,
    RECOMMENDATION_COMPLETED: 5,
    RECOMMENDATION_FAILED: 6,
    NOT_STARTED: 7,
    EXTRACTED_TEXT_FAILED: 8,
    CREATED_QUERY_FAILED: 9,
    FETCHING_JOBS_FAILED: 10,
    JOBS_FETCHED_FAILED: 11
};
